module.exports = __webpack_public_path__ + "73092878a3f77c3b45cd33ad14e9fc02.svg";